// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1RPwZ","wrapper":"wrapper___tMbF2","logo":"logo___wVBwV","info":"info___3Y4Wa","modal":"modal___3Zooz","header":"header___3vKrD","body":"body___3vFHU","close":"close___1Ijoc","overlay":"overlay___3sAv-","hidden":"hidden___1BSkD","form":"form___3AE8r","gapBottom45":"gapBottom45___2hVOg","gapTop20":"gapTop20___SlhtV","content":"content___3ITR0","package":"package___2nT2Q","unit":"unit___1SehV","label":"label___PYMjf","intro":"intro___zIOkK"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Page1.scss
// module id = 30
// module chunks = 0